export function getEnvVarOptional(name) {
    return process.env[name]?.trim() || null;
}
export function getEnvVarRequired(name) {
    const value = process.env[name]?.trim();
    if (!value) {
        throw new Error(`Missing environment variable: ${name}`);
    }
    return value;
}
export const config = {
    environment: {
        stage: getEnvVarRequired('SCHADENKI_PUBLIC_ENVIRONMENT_STAGE'),
        build: getEnvVarRequired('SCHADENKI_PUBLIC_ENVIRONMENT_BUILD'),
    },
    app: {
        admin: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_APP_ADMIN_BASEURL'),
        },
        claimDesk: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_APP_CLAIMDESK_BASEURL'),
        },
        cockpit: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_APP_COCKPIT_BASEURL'),
        },
        dkmCockpit: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_APP_DKMCOCKPIT_BASEURL'),
        },
        vemaCockpit: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_APP_VEMACOCKPIT_BASEURL'),
        },
        mlpCockpit: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_APP_MLPCOCKPIT_BASEURL'),
        },
        innoasCockpit: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_APP_INNOASCOCKPIT_BASEURL'),
        },
        selfService: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_APP_SELFSERVICE_BASEURL'),
        },
        serviceAddin: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_APP_SERVICEADDIN_BASEURL'),
            portalOrigins: (getEnvVarOptional('SCHADENKI_PUBLIC_SERVICEADDIN_PORTAL_ORIGINS') ?? '')
                .split(',')
                .map((origin) => origin.trim().replace(/\/$/, ''))
                .filter((origin) => origin.length > 0),
        },
        docs: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_APP_DOCS_BASEURL'),
        },
    },
    service: {
        admin: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_ADMIN_BASEURL'),
        },
        claimDesk: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_CLAIMDESKAPI_BASEURL'),
        },
        cockpit: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_COCKPITAPI_BASEURL'),
        },
        dkmCockpitApi: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_DKMCOCKPITAPI_BASEURL'),
        },
        vemaCockpitApi: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_VEMACOCKPITAPI_BASEURL'),
        },
        mlpCockpitApi: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_MLPCOCKPITAPI_BASEURL'),
        },
        innoasCockpitApi: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_INNOASCOCKPITAPI_BASEURL'),
        },
        selfService: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_SELFSERVICE_BASEURL'),
        },
        externalApi: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_EXTERNALAPI_BASEURL'),
        },
        pipeline: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_PIPELINE_BASEURL'),
        },
        serviceAddin: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_SERVICEADDINAPI_BASEURL'),
        },
        docsApi: {
            baseUrl: getEnvVarRequired('SCHADENKI_PUBLIC_SERVICE_DOCSAPI_BASEURL'),
        },
    },
    auth: {
        admin: {
            tenant: (() => {
                const mode = getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_ADMIN_TENANT_MODE');
                if (mode === 'single') {
                    return { mode, id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_ADMIN_TENANT_ID') };
                }
                return {
                    mode,
                    ids: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_ADMIN_TENANT_IDS').split(','),
                };
            })(),
            client: {
                id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_ADMIN_CLIENT_ID'),
            },
        },
        claimDesk: {
            tenant: (() => {
                const mode = getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_CLAIMDESK_TENANT_MODE');
                if (mode === 'single') {
                    return { mode, id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_CLAIMDESK_TENANT_ID') };
                }
                return {
                    mode,
                    ids: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_CLAIMDESK_TENANT_IDS').split(','),
                };
            })(),
            client: {
                id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_CLAIMDESK_CLIENT_ID'),
            },
        },
        cockpit: {
            tenant: (() => {
                const mode = getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_COCKPIT_TENANT_MODE');
                if (mode === 'single') {
                    return { mode, id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_COCKPIT_TENANT_ID') };
                }
                return {
                    mode,
                    ids: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_COCKPIT_TENANT_IDS').split(','),
                };
            })(),
            client: {
                id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_COCKPIT_CLIENT_ID'),
            },
        },
        dkmCockpit: {
            tenant: (() => {
                const mode = getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_DKMCOCKPIT_TENANT_MODE');
                if (mode === 'single') {
                    return { mode, id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_DKMCOCKPIT_TENANT_ID') };
                }
                return {
                    mode,
                    ids: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_DKMCOCKPIT_TENANT_IDS').split(','),
                };
            })(),
            client: {
                id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_DKMCOCKPIT_CLIENT_ID'),
            },
        },
        vemaCockpit: {
            tenant: (() => {
                const mode = getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_VEMACOCKPIT_TENANT_MODE');
                if (mode === 'single') {
                    return { mode, id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_VEMACOCKPIT_TENANT_ID') };
                }
                return {
                    mode,
                    ids: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_VEMACOCKPIT_TENANT_IDS').split(','),
                };
            })(),
            client: {
                id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_VEMACOCKPIT_CLIENT_ID'),
            },
        },
        mlpCockpit: {
            tenant: (() => {
                const mode = getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_MLPCOCKPIT_TENANT_MODE');
                if (mode === 'single') {
                    return { mode, id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_MLPCOCKPIT_TENANT_ID') };
                }
                return {
                    mode,
                    ids: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_MLPCOCKPIT_TENANT_IDS').split(','),
                };
            })(),
            client: {
                id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_MLPCOCKPIT_CLIENT_ID'),
            },
        },
        innoasCockpit: {
            tenant: (() => {
                const mode = getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_INNOASCOCKPIT_TENANT_MODE');
                if (mode === 'single') {
                    return { mode, id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_INNOASCOCKPIT_TENANT_ID') };
                }
                return {
                    mode,
                    ids: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_INNOASCOCKPIT_TENANT_IDS').split(','),
                };
            })(),
            client: {
                id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_INNOASCOCKPIT_CLIENT_ID'),
            },
        },
        serviceAddin: (() => {
            const mode = getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_SERVICEADDIN_MODE');
            if (mode === 'block-all') {
                return {
                    mode,
                };
            }
            if (mode === 'demo') {
                // Forces every request through the demo fixtures/no-op path
                // regardless of the bearer token. Intended for local/standalone
                // previews of the add-in without a portal handshake; do NOT
                // enable in production.
                return {
                    mode,
                };
            }
            if (mode === 'accept-all') {
                return {
                    mode,
                    user: JSON.parse(getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_SERVICEADDIN_USER')),
                };
            }
            return {
                mode,
                tenant: {
                    id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_SERVICEADDIN_TENANT_ID'),
                    subdomain: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_SERVICEADDIN_TENANT_SUBDOMAIN'),
                },
                client: {
                    id: getEnvVarRequired('SCHADENKI_PUBLIC_AUTH_SERVICEADDIN_CLIENT_ID'),
                },
            };
        })(),
    },
    backend: {
        stage: getEnvVarRequired('SCHADENKI_PUBLIC_BACKEND_STAGE'),
    },
    applicationInsights: {
        connectionString: getEnvVarRequired('SCHADENKI_PUBLIC_APPLICATIONINSIGHTS_CONNECTIONSTRING'),
    },
    support: {
        email: getEnvVarRequired('SCHADENKI_PUBLIC_SUPPORT_EMAIL'),
    },
    googleMaps: {
        apiKey: getEnvVarRequired('SCHADENKI_PUBLIC_GOOGLEMAPS_APIKEY'),
    },
};
export function isProductionEnvironment() {
    // Case-insensitive on purpose: this guards destructive operations (e.g. the weekly
    // system reset), so a casing difference in the stage value must never fail open.
    const stage = config.environment.stage.toLowerCase();
    return stage.includes('prod') || stage.includes('prd');
}
// Whether the application itself provisions Cosmos DB containers at runtime
// (via createIfNotExists). This is only enabled on the legacy staging and
// production deployments, which are not yet covered by Terraform container
// provisioning. Every other stage relies exclusively on Terraform to create the
// containers, so the app must only bind to already-existing containers.
export function isAppManagedCosmosContainerCreationEnabled() {
    return config.environment.stage === 'staging' || config.environment.stage === 'production';
}
